import { createSlice } from '@reduxjs/toolkit';

const gradingSlice = createSlice({
  name: 'grading',
  initialState: {
    gradingResults: [],
    markedScreenshots: [],
    submissions: [],
    inGradingMode: false,
    submissionUuids: {},
    referenceFile: null,
  },
  reducers: {
    storeSubmissions(state, { payload }) {
      state.submissions = payload;
    },
    setGradingResults(state, { payload }) {
      state.gradingResults = payload;
    },
    setMarkedScreenshots(state, { payload }) {
      state.markedScreenshots = payload;
    },
    setGradingMode(state, { payload }) {
      state.inGradingMode = payload;
    },
    setSubmissionUuids(state, { payload }) {
      state.submissionUuids = payload;
    },
    storeReferenceFile(state, { payload }) {
      state.referenceFile = payload;
    },
  },
});

export default gradingSlice;
